var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20.571,
    viewBox: "0 0 24 20.571",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "menus",
    d: "M27,5.714A1.714,1.714,0,0,0,25.286,4H4.714a1.714,1.714,0,0,0,0,3.429H25.286A1.714,1.714,0,0,0,27,5.714Zm0,8.571a1.714,1.714,0,0,0-1.714-1.714H4.714a1.714,1.714,0,0,0,0,3.429H25.286A1.714,1.714,0,0,0,27,14.286Zm0,8.571a1.714,1.714,0,0,0-1.714-1.714H15a1.714,1.714,0,0,0,0,3.429H25.286A1.714,1.714,0,0,0,27,22.857Z",
    transform: "translate(-3 -4)",
    fill: "#efc04b",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuActive);
export default __webpack_public_path__ + "static/media/menu-active.e2ea425787528ef9ad1ce647d81d7147.svg";
export { ForwardRef as ReactComponent };